<div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.about_miracle' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.add_about_miracle' | translate }}</p>
          </div>
        </div>

<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="about-section">
      <div class="row">

    
        <!-- 🌐 English Section -->
        <div class="col-md-6 col-12 mb-3">
          <div class="card shadow-sm border-0 rounded-3">
           
            <div class="card-body">
              <label class="form-label fw-bold">
                {{ 'MENU.DASHBOARD.title_en' | translate }}
              </label>
              <input
                type="text"
                class="form-control mb-2"
                [(ngModel)]="vision.title_en"
                placeholder="{{ 'MENU.DASHBOARD.enter_title_en' | translate }}"
              />

              <label class="form-label fw-bold">
               {{ 'MENU.DASHBOARD.content_en' | translate }}
              </label>
              <textarea
                class="form-control content-textarea mt-1"
                [(ngModel)]="vision.content_en"
                rows="6"
                placeholder="{{ 'MENU.DASHBOARD.write_content_en' | translate }}"
              ></textarea>
            </div>
          </div>
        </div>

        <!-- 🇸🇦 Arabic Section -->
        <div class="col-md-6 col-12 mb-3">
          <div class="card shadow-sm border-0 rounded-3">
        
            <div class="card-body">
              <label class="form-label fw-bold">
                {{ 'MENU.DASHBOARD.title_ar' | translate }}
              </label>
              <input
                type="text"
                class="form-control mb-2"
                [(ngModel)]="vision.title_ar"
                placeholder="{{ 'MENU.DASHBOARD.enter_title_ar' | translate }}"
              />

              <label class="form-label fw-bold">
                {{ 'MENU.DASHBOARD.content_ar' | translate }}
              </label>
              <textarea
                class="form-control content-textarea mt-1"
                [(ngModel)]="vision.content_ar"
                rows="6"
                placeholder="{{ 'MENU.DASHBOARD.write_content_ar' | translate }}"
              ></textarea>
            </div>
          </div>
        </div>

      </div>


      <!-- ✅ Unified Save Button -->
      <div class="text-center mt-4">
        <button class="btn btn-primary px-5 py-2 save-btn" (click)="updateProduct()">
          {{ 'MENU.DASHBOARD.save_changes' | translate }}
        </button>
      </div>
    </section>
  </div>
</div>
